import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
    selector: "medicationallergies-information-modal",
    templateUrl: "./medicationallergies-information-modal.component.html",
    styleUrls: ["./medicationallergies-information-modal.component.scss"],
})
export class MedicationAllergiesInformationModalComponent implements OnInit {
    constructor(public activeModal: NgbActiveModal) {}

    @Input() SummaryData: any;
    @Output() readonly Response: EventEmitter<any> = new EventEmitter();
    error = "";
    public checklist: Array<any> = [];
    public others: string = "";

    ngOnInit() {
        this.checklist = [
            {
                name: "Aspirin, Advil (or other NSAIDs)",
                value: false,
            },
            {
                name: "Cephalosporins",
                value: false,
            },
            {
                name: "Dilantin",
                value: false,
            },
            {
                name: "General anesthetics",
                value: false,
            },
            {
                name: "Intravenous contrast dye (with Iodine)",
                value: false,
            },
            {
                name: "Local anesthetics",
                value: false,
            },
            {
                name: "Penicillin",
                value: false,
            },
            {
                name: "Sulfonamides (sulfa)",
                value: false,
            },
            {
                name: "Tegretol (carbamazepine)",
                value: false,
            },
            {
                name: "Tetracycline",
                value: false,
            },
            {
                name: "Tylenol",
                value: false,
            },
        ];
        this.setupForm();
    }
    setupForm() {
        let pmh = this.SummaryData.summary.medicationallergies.allergies;

        if (pmh && pmh.length > 0) {
            pmh.forEach((item) => {
                this.checklist.forEach((c, i) => {
                    if (item.name === c.name) {
                        c.value = true;

                        if (item.subset && item.subset.length > 0) {
                            if (c.subset && c.subset.length > 0) {
                                item.subset.forEach((isub) => {
                                    c.subset.forEach((csub) => {
                                        if (isub.name === csub.name) {
                                            csub.value = true;
                                        }
                                    });
                                });
                            }
                        }
                    }
                });
            });
        }
        if (this.SummaryData.summary.medicationallergies.other && this.SummaryData.summary.medicationallergies.other.trim().length > 0) {
            this.others = this.SummaryData.summary.medicationallergies.other;
        }
    }

    isChecklistValid(): boolean {
        let isValid = true;
        this.checklist.forEach((item) => {
            if (item.value === true) {
                if (item.subset && item.subset.length > 0) {
                    let selectedSub = item.subset.filter((i) => i.value === true);
                    if (selectedSub.length === 0) {
                        isValid = false;
                    }
                }
            }
        });

        if (!isValid) {
            this.error = "Please make sure sub-categories are also selected.";
        }

        return isValid;
    }

    getSelectedData() {
        let selectedData = [];

        this.checklist.forEach((item) => {
            if (item.value === true) {
                let i = item;

                if (item.subset) {
                    let s = [];

                    item.subset.forEach((sub) => {
                        if (sub.value === true) {
                            s.push(sub);
                        }
                    });

                    i.subset = s;
                }

                selectedData.push(i);
            }
        });
        return selectedData;
    }
    public onSave() {
        if (this.isChecklistValid()) {
            this.SummaryData.summary.medicationallergies = { allergies: this.getSelectedData() };

            if (this.others.trim().length > 0) {
                this.SummaryData.summary.medicationallergies["other"] = this.others;
            }
            this.Response.emit({ success: true, message: "", action: "edit", updatedSummaryData: this.SummaryData.summary, section: "medication" });
            this.activeModal.close();
        }
    }
    public onCancel() {
        this.Response.emit({ success: true, message: "", action: "edit", updatedSummaryData: this.SummaryData.summary, section: "medication" });
        this.activeModal.close();
    }
}
